import type { paths } from "@/api-schema";
import { optionsWithDefaults } from "@/common/api/_helpers/options-with-defaults";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { Options } from "../_types";

export const FIT_SETTINGS_GET_RESOURCE = "fit-settings" as const;
export const FIT_SETTINGS_GET_API_PATH = `/v1/${FIT_SETTINGS_GET_RESOURCE}` as const;

export type FitSettingsGetParameters = paths[typeof FIT_SETTINGS_GET_API_PATH]["get"]["parameters"]["query"];
export type FitSettingsGetResponse =
  paths[typeof FIT_SETTINGS_GET_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useFitSettingsGetQuery(options?: Options<FitSettingsGetParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<FitSettingsGetParameters, never>>(options);
  const requestParameters = optionsWithDefaultsResolved.parameters ?? {};

  return useQuery({
    queryKey: [FIT_SETTINGS_GET_RESOURCE, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<FitSettingsGetResponse>(FIT_SETTINGS_GET_API_PATH, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
